<template>
  <dropdown
    ref="inputDropdown"
    :force-visibility="isOpen"
    :is-disabled="isDisabled"
    title="Saved Replies"
    class="editor-saved-replies__dropdown"
    @open="isOpen = true"
    @close="isOpen = false"
  >
    <div class="editor-saved-replies__button">
      <i class="ddi-saved-replies ddi" />
      <i class="ddi-caret-down ddi" />
    </div>

    <template #content>
      <div>
        <ul>
          <li
            v-for="(item, index) in savedReplies"
            :key="index"
            @click="handleSelect(item, index)"
          >
            <span :class="{ selected: selectedIndex === index }">
              {{ item.title }}
            </span>
          </li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>
<script lang="ts">
import { IConvertedSavedReply } from '@/api/types/response.types'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EditorSavedReplies',

  props: {
    savedReplies: {
      type: Array as () => IConvertedSavedReply[],
      default: Array as () => IConvertedSavedReply[],
    },

    message: {
      type: String,
      default: '',
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['selected-saved-reply'],

  data() {
    return {
      isOpen: false,
      selectedIndex: null as any,
      selectedReplyBody: '',
    }
  },

  watch: {
    message(value: string) {
      // remove HTML to compare only the content of the saved reply
      const valueWithoutHTML = value.replace(/<(?!\s*\/?\s*img)[^>]*>/gi, '')
      const selectedWithoutHTML = this.selectedReplyBody.replace(
        /<(?!\s*\/?\s*img)[^>]*>/gi,
        '',
      )

      if (valueWithoutHTML !== selectedWithoutHTML) {
        this.selectedReplyBody = ''
        this.selectedIndex = null
      }
    },
  },

  methods: {
    handleSelect(item: IConvertedSavedReply, index: number) {
      this.selectedIndex = index
      this.setSelectedReply(item.body)
      this.isOpen = false
    },

    /**
     * Emit event to Editor to apply the saved reply
     */
    setSelectedReply(savedReplyBody: string) {
      this.selectedReplyBody = savedReplyBody
      this.$emit('selected-saved-reply', savedReplyBody)
    },
  },
})
</script>

<style lang="scss">
.editor-saved-replies {
  &__button {
    display: flex !important;
    align-items: flex-end;
    color: var(--color-text-primary);

    .ddi-saved-replies {
      top: 2px;
      font-size: 16px;
    }

    .ddi-caret-down {
      left: 6px;
      top: -2px;
      font-size: 10px;
    }

    &:hover {
      color: $bluish;
    }

    &::before {
      display: inline-block;
      width: 1px;
      height: 16px;
      margin: 0 12px 0 8px;
      vertical-align: text-top;
      content: '';
      background: $color--gray-60;
      border-radius: 3px;
      opacity: 0.56;
    }
  }

  &__dropdown {
    display: flex !important;
    align-items: center;

    .dropdown__popper {
      min-width: 240px;
      max-width: 240px;
    }
  }
}
</style>
